/* Kundenavnene ruller forbi, og farten følger hvor fort man scroller.
 *
 * Sporet dupliseres slik at det kan løkkes sømløst. Kopien merkes aria-hidden,
 * ellers leser skjermlesere hvert navn to ganger.
 *
 * Med «reduser bevegelse» står navnene stille. */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { $, $$, mindreBevegelse, klem } from '../kjerne/verktoy.js';

export function startMarquee() {
  const rader = $$('.rulletekst');
  if (!rader.length || mindreBevegelse.matches) return;

  const spor = rader.map(rad => {
    const original = $('.rulletekst-spor', rad);
    const kopi = original.cloneNode(true);
    kopi.setAttribute('aria-hidden', 'true');
    // Kopien legges inn i samme spor, så de to følger hverandre.
    for (const barn of [...kopi.children]) original.append(barn);
    return { el: original, x: 0, retning: +rad.dataset.retning, bredde: 0 };
  });

  const mal = () => { for (const s of spor) s.bredde = s.el.scrollWidth / 2; };
  mal();
  addEventListener('resize', mal);
  document.fonts?.ready.then(mal);

  let fart = 0;
  ScrollTrigger.create({
    trigger: '#referanser',
    start: 'top bottom',
    end: 'bottom top',
    onUpdate: selv => { fart = klem(selv.getVelocity() / 180, -14, 14); },
  });

  gsap.ticker.add((tid, dt) => {
    fart *= .93;
    for (const s of spor) {
      s.x += (1.1 + Math.abs(fart)) * s.retning * (Math.sign(fart) || 1) * dt * .06;
      if (s.x <= -s.bredde) s.x += s.bredde;
      if (s.x > 0) s.x -= s.bredde;
      s.el.style.transform = `translate3d(${s.x}px, 0, 0) skewX(${-fart * .5}deg)`;
    }
  });
}
